import { Routes, Route } from "react-router-dom";
import CargoDocuments from "view/documents/cargos/CargoDocuments";

const index = () => {
	return (
		<Routes>
			<Route path='/cargos' element={<CargoDocuments />} />
		</Routes>
	);
};

export default index;
